// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"592":"3cd6e118","880":"3fc1a291"}[chunkId] + ".css";
};